<script lang="ts" setup>
import { ref, PropType, computed, nextTick } from "vue";
import { DocumentSpace } from "@/graphql/operations";
import AccessModalEdit from "./AccessModalEdit.vue";
import AccessModalAdd from "./AccessModalAdd.vue";

const visibleUserLimit = 3;

const props = defineProps({
  documentSpace: {
    type: Object as PropType<DocumentSpace>,
    required: true,
  },
});

const visibleUserCount = computed(() => {
  return props.documentSpace.documentSpaceAccesses.nodes.reduce(
    (accumulator, access) =>
      accumulator + (access?.displayContactDetails ? 1 : 0),
    0,
  );
});

const state = ref<"edit" | "add">("edit");
const accessModalEdit = ref<InstanceType<typeof AccessModalEdit>>();
const displayAdd = () => {
  state.value = "add";
};
const displayEdit = () => {
  state.value = "edit";
  void nextTick(() => accessModalEdit.value?.focusUserSearchActivation());
};
</script>

<template>
  <access-modal-edit
    v-if="state === 'edit'"
    ref="accessModalEdit"
    :documentSpace="props.documentSpace"
    :visibleUserCount="visibleUserCount"
    :visibleUserLimit="visibleUserLimit"
    @changeState="displayAdd"
  />

  <access-modal-add
    v-else
    :documentSpace="props.documentSpace"
    :visibleUserCount="visibleUserCount"
    :visibleUserLimit="visibleUserLimit"
    @changeState="displayEdit"
  />
</template>
